// config/index.js
const baseConfig = {
  // 共享配置项
};

let envConfig = {};
const env = process.env.NODE_ENV || 'development';

if (env === 'development') {
  envConfig = require('./development.env');
} else if (env === 'production') {
  envConfig = require('./production.env');
}

const config = Object.assign({}, baseConfig, envConfig);

export default config;




// WEBPACK FOOTER //
// ./src/configPort/index.js